export const h ={
    "common": {
        "webSuffix": "- QIDI Tech起迪科技",
        "email": "郵箱",
        "password": "密碼",
        "verificationCode": "驗證碼",
        "username": "用戶名",
        "readAndAgree": "我同意",
        "and": "和",
        "userAgreement": "使用者協定",
        "privacyPolicy": "隱私政策",
        "copy": "版權所有 ©  2025起迪保留所有權",
        "sendVerificationCode": "發送驗證碼",
        "Sending": "發送中",
        "tryAgainInSeconds": "秒後重試",
        "userNameRequired": "請輸入用戶名",
        "passwordInputLabel": "請輸入密碼",
        "checkPasswordInputLabel": "請輸入確認密碼",
        "userEmailRequired": "請輸入郵箱地址",
        "userEmailInvalid": "請輸入正確的郵箱地址",
        "emailCodeRequired": "請輸入驗證碼",
        "newPasswordInputLabel": "請輸入新密碼",
        "confirmPasswordInputLabel": "請再次輸入密碼",
        "passwordMismatchErrorLabel": "兩次輸入密碼不一致",
        "agreementRequired": "請閱讀並同意協定",
        "tip": "提示",
        "tipAlreadyLogin": "檢測到您已經登入，為您跳轉到用戶中心",
        "tipWelcomeBack": "歡迎回來~",
        "tipDeleteAccountFail": "删除帳號失敗，删除帳號介面暫時關閉中",
        "pleaseAgreeFirst": "請先同意",
        "agree": "同意",
        "refuse": "拒絕",
        "tipNeedLogin": "請先登錄",
        "tipChangePasswordSuccess": "修改密碼成功，為您跳轉到登入頁面",
        "tipGetUserInfoSuccess": "獲取資訊成功",
        "tipGetUserInfoFail": "獲取資訊失敗",
        "tipLoginOut": "登出",
        "delete": "删除",
        "back": "返回",
        "init": "初始化",

        "passwordInputLengthErrorLabel": "密碼長度應該在6到20之間",
        "changePasswordFail": "原密碼錯誤",
        "tipDeleteAccountSuccess": "删除帳戶成功",
        "emailCodeSentSuccess": "驗證碼已下發",
        "emailCodeSentFail": "驗證碼下發失敗",
        "emailLoginFail": "驗證碼已過期",
        "passwordLoginFail": "登入密碼錯誤",
        "editUserInfoSuccess": "修改用戶資訊成功",
        "registerSuccess": "注册成功",
        "registerFail": "注册失敗",
        "registerEmailExistFail": "郵箱已存在",

        "resMessageTip0": "未知資訊",
        "resMessageTip1": "密碼錯誤",
        "resMessageTip2": "密碼長度應該在6到20之間",
        "resMessageTip3": "帳號錯誤",
        "resMessageTip4": "驗證碼已下發",
        "resMessageTip5": "驗證碼下發失敗",
        "resMessageTip6": "驗證碼已過期",
        "resMessageTip7": "密碼錯誤",
        "resMessageTip8": "密碼不可以與舊密碼相同",
        "resMessageTip9": "郵箱已存在",
        "resMessageTip10": "注册成功",
        "resMessageTip11": "注册失敗",
        "resMessageTip12": "修改用戶資訊成功",
        "resMessageTip13": "修改用戶資訊失敗",
        "resMessageTip14": "獲取成功",
        "resMessageTip15": "獲取失敗",
        "resMessageTip16": "修改密碼成功",
        "resMessageTip17": "修改密碼失敗",
        "resMessageTip18": "重置密碼成功",
        "resMessageTip19": "重置密碼失敗",
        "resMessageTip20": "登入成功",
        "resMessageTip21": "登入失敗",
        "resMessageTip22": "删除帳號成功",
        "resMessageTip23": "删除帳號失敗",
        "resMessageTip24": "驗證碼有誤",
        "noUserInfoError": "網絡錯誤，請重新登入"
    },
    "changePassword": {
        "newPassword": "新密碼"
    },
    "deleteUser": {
        "tipDeleteUser": "很遺憾您要離開了。 一旦您的帳號被删除，您所有的個人數據將永久消失且無法恢復。",
        "accountDeletionTerms": "帳號删除條款"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "通過郵箱找回密碼",
        "confirmPassword": "確認密碼",
        "resettingPassword": "重置密碼",
        "resetting": "重置"
    },
    "login": {
        "passwordLogin": "密碼登入",
        "verifyLogin": "驗證登入",
        "accountRegistration": "帳號注册",
        "forgotPassword": "忘記密碼",
        "login": "登入",
        "localLogin": "本地登入",
        "loginOut": "登出",
        "continueOnYourWay": "繼續前往"
    },
    "register": {
        "registerAnAccount": "註冊帳號",
        "register": "注册"
    },
    "userCenter": {
        "personalInformation": "個人資料",
        "modifyInformation": "修改資訊",
        "changePassword": "修改密碼",
        "cancelAccount": "註銷帳號",
        "exitAccount": "退出帳號",
        "change": "修改",
        "maxCharLimitTip": "用戶名長度不能超過10個漢字",
    },
    "policies": {
        "deleteAccountPrivacy": "删除帳號協定",
        "agreement": "使用協定",
        "privacyPolicy": "隱私政策"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "選擇你的國家或地區",
        "recommendedVisits": "推薦訪問",
        "NorthAmerica": "北美洲",
        "Europe": "歐洲",
        "Asia": "亞洲",
        "Other": "其他",
    }
}

export const aAndL ={
    "ar": {
        "Country": "阿拉伯",
        "Language": "阿拉伯語"
    },
    "cs": {
        "Country": "捷克",
        "Language": "捷克語"
    },
    "de": {
        "Country": "德國",
        "Language": "德語"
    },
    "en": {
        "Country": "英國",
        "Language": "英語"
    },
    "es": {
        "Country": "西班牙",
        "Language": "西班牙語"
    },
    "fr": {
        "Country": "法國",
        "Language": "法語"
    },
    "he": {
        "Country": "以色列",
        "Language": "希伯來語"
    },
    "hu": {
        "Country": "匈牙利",
        "Language": "匈牙利語"
    },
    "it": {
        "Country": "義大利",
        "Language": "義大利語"
    },
    "ja": {
        "Country": "日本",
        "Language": "日語"
    },
    "ko": {
        "Country": "韓國",
        "Language": "韓語"
    },
    "nl": {
        "Country": "荷蘭",
        "Language": "荷蘭語"
    },
    "pt": {
        "Country": "葡萄牙",
        "Language": "葡萄牙語"
    },
    "pt_BR": {
        "Country": "葡萄牙（巴西）",
        "Language": "葡萄牙語（巴西）"
    },
    "ru": {
        "Country": "俄國",
        "Language": "俄語"
    },
    "sv": {
        "Country": "瑞典",
        "Language": "瑞典語"
    },
    "tr": {
        "Country": "土耳其",
        "Language": "土耳其語"
    },
    "uk": {
        "Country": "烏克蘭",
        "Language": "烏克蘭語"
    },
    "zh": {
        "Country": "中國大陸",
        "Language": "簡體中文"
    },
    "zh_tw": {
        "Country": "中國臺灣",
        "Language": "繁體中文"
    },
    "Canada": {
        "Country": "加拿大",
        "Language": "英語"
    },
    "United_States": {
        "Country": "美國",
        "Language": "英語"
    },
    "United_Kingdom": {
        "Country": "英國",
        "Language": "英語"
    },
    "EU_Countries": {
        "Country": "歐盟國家",
        "Language": "英語"
    },
    "Australia": {
        "Country": "澳大利亞",
        "Language": "英語"
    },
    "globalzh": {
        "Country": "全球",
        "Language": "簡體中文"
    },
    "globalen": {
        "Country": "Global",
        "Language": "英語"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/zh_tw.js